import { createModal } from '/@/core/elements/modal'

interface WelcomeModalData {
  projectName: string
  onEditProject: () => void
  onCreateViz: () => void
  onVisitHomepage: () => void
}

const { api, component } = createModal<WelcomeModalData>(
  'WelcomeModal',
  () => import('./WelcomeModal.vue'),
)

export const useWelcomeModal = api
export default component
